import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { ThemeProvider } from "./contexts/ThemeContext";
import Sidebar from "./components/Sidebar";
import WorkspaceDashboard from "./components/WorkspaceDashboard";
import WorkspaceUsers from "./components/WorkspaceUsers";
import WorkspaceAnalytics from "./components/WorkspaceAnalytics";
import Revenue from "./components/Revenue";
import AiAnalyst from "./components/AiAnalyst";
import AiChatWidget from "./components/AiChatWidget";
import AccessKeyGate from "./components/AccessKeyGate";
// Commented out to reduce page load - these pages are disabled
// import WorkspaceStorage from "./components/WorkspaceStorage";
// import InvestorMatrix from "./components/InvestorMatrix";
// import Users from "./components/Users";

const MobileMenuButton = ({ isOpen, onClick }) => (
	<button
		className={`mobile-hamburger ${isOpen ? "open" : ""}`}
		onClick={onClick}
		aria-label="Toggle menu"
	>
		<span></span>
		<span></span>
		<span></span>
	</button>
);

const CloseSidebarOnNavigate = ({ onClose }) => {
	const location = useLocation();
	useEffect(() => {
		onClose();
	}, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
	return null;
};

function App() {
	const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);
	const closeMobileMenu = () => setIsMobileMenuOpen(false);

	return (
		<ThemeProvider>
			<AccessKeyGate>
			<Router>
				<CloseSidebarOnNavigate onClose={closeMobileMenu} />
				<div className="App">
					<Sidebar
						isCollapsed={isSidebarCollapsed}
						setIsCollapsed={setIsSidebarCollapsed}
						isMobileOpen={isMobileMenuOpen}
					/>
					{isMobileMenuOpen && (
						<div className="mobile-overlay" onClick={closeMobileMenu} />
					)}
					<MobileMenuButton isOpen={isMobileMenuOpen} onClick={toggleMobileMenu} />
					<div
						className={`main-content ${isSidebarCollapsed ? "sidebar-collapsed" : ""}`}
					>
						<Routes>
							<Route path="/" element={<WorkspaceDashboard />} />
							<Route
								path="/workspaces"
								element={<WorkspaceDashboard />}
							/>
							<Route
								path="/analytics"
								element={<WorkspaceAnalytics />}
							/>
							<Route
								path="/revenue"
								element={<Revenue />}
							/>
							<Route
								path="/ai-analyst"
								element={<AiAnalyst />}
							/>
							{/* Commented out routes - these pages are disabled
							<Route
								path="/users"
								element={<Users />}
							/>
							<Route
								path="/workspace-storage"
								element={<WorkspaceStorage />}
							/>
							<Route
								path="/investor-matrix"
								element={<InvestorMatrix />}
							/>
							*/}
							<Route
								path="/workspace/:workspaceId/:workspaceName/users"
								element={<WorkspaceUsers />}
							/>
						</Routes>
					</div>
					<AiChatWidget />
				</div>
			</Router>
			</AccessKeyGate>
		</ThemeProvider>
	);
}

export default App;
